import type { SxProps, Theme } from '@mui/material';

export const layoutRootSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
};

export const layoutToolbarSx: SxProps<Theme> = {
  py: { xs: 1, sm: 1.5 },
};

export const layoutLogoLinkSx: SxProps<Theme> = {
  flexGrow: 1,
  color: 'primary.main',
  fontSize: { xs: '1.1rem', sm: '1.25rem' },
  fontWeight: 700,
  letterSpacing: '0.05em',
  transition: 'color 0.2s ease',
  '&:hover': {
    color: 'primary.light',
  },
};

export const layoutNavBoxSx: SxProps<Theme> = {
  display: 'flex',
  gap: { xs: 0.5, sm: 1 },
};

export const layoutNavButtonSx: SxProps<Theme> = {
  fontSize: { xs: '0.875rem', sm: '1rem' },
  px: { xs: 1, sm: 1.5 },
  '&:hover': {
    backgroundColor: 'action.hover',
  },
};

export const layoutMainContainerSx: SxProps<Theme> = {
  flexGrow: 1,
  py: { xs: 2, sm: 3, md: 4 },
  px: { xs: 2, sm: 2 },
};

export const layoutFooterSx: SxProps<Theme> = {
  py: { xs: 2, sm: 3 },
  px: { xs: 2, sm: 2 },
  textAlign: 'center',
  borderTop: '1px solid',
  borderColor: 'divider',
  backgroundColor: 'background.paper',
  opacity: 0.7,
};

export const layoutFooterLinkSx: SxProps<Theme> = {
  color: 'primary.main',
};
